import React, { useEffect, useState } from 'react';
import { getThemeAsync, updateThemeAsync } from '../../Services/ThemeService';
import Card from '../../Shared/Components/Card/Card';
import PrimaryButton from '../../Shared/Components/PrimaryButton/PrimaryButton';
import Header from './../../Shared/Components/Header/Header';
import './ThemeSettings.scss';
import LineIcon from 'react-lineicons';

const ThemeSettings = () => {
    const [state, setState] = useState({
        primaryButtonColour: "",
        secondaryButtonColour: "",
        primaryNavColour: "",
        secondaryNavColour: "",
        primaryNavFontColour: "",
        secondaryNavFontColour: "",
        iconColour: "",
        favicon: "",
        sidebarIconColour: ""
    });

    useEffect(() => {
        getCurrentTheme();
    }, []);

    const getCurrentTheme = async () => {
        let response = await getThemeAsync();
        setState(response.config);
    }

    const handleChange = async evt => {
        setState({ ...state, [evt.target.name]: evt.target.value });
    }

    const handleFileChange = evt => {
        let value = evt.target.files[0];
        let logoUrl = URL.createObjectURL(value);
        let name = evt.target.name;
        let fileName = evt.target.name + 'FileName';
        let url = evt.target.name + 'Url';

        setState({ ...state, [name]: value, [url]: logoUrl, [fileName]: evt.target.files[0].name });
    }

    const handleSubmit = async () => {
        let form = new FormData();
        form.append("primaryNavColour", state.primaryNavColour);
        form.append("secondaryNavColour", state.secondaryNavColour);
        form.append("primaryButtonColour", state.primaryButtonColour);
        form.append("secondaryButtonColour", state.secondaryButtonColour);
        form.append("primaryNavFontColour", state.primaryNavFontColour);
        form.append("secondaryNavFontColour", state.secondaryNavFontColour);
        form.append("iconColour", state.iconColour);
        form.append("sidebarIconColour", state.sidebarIconColour);
        form.append("logo", state.logo);
        form.append("loadingLogo", state.loadingLogo);
        form.append("favicon", state.favicon);

        await updateThemeAsync(form);
        window.location.reload();
    }

    return (
        <>
            <Header heading="Theme Configuration" subheading="Customize your platform's branding and appearance" icon="brush" />
            <div className="container-fluid content">
                <div className="row">
                    <div className="col-12">
                        <h5 className="section-title mb-3">Brand Assets</h5>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-12 theme">
                        <Card>
                            <div className="row g-4">
                                <div className="col-12 col-md-4">
                                    <div className="upload-card">
                                        <label className="upload-label">Sidebar Logo</label>
                                        <div className="upload-preview">
                                            {state.logoUrl ?
                                                <img alt="Company logo" src={state.logoUrl} className="img-fluid" />
                                                :
                                                <div className="empty-state">
                                                    <LineIcon name="image" />
                                                    <span>No logo uploaded</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="custom-file">
                                            <input value={""} className="custom-file-input" accept=".png, .jpeg, .jpg" name="logo" id="logo" type="file" onChange={handleFileChange} />
                                            <label className="custom-file-label">{state.logoFileName ? state.logoFileName : "Choose file..."}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4">
                                    <div className="upload-card">
                                        <label className="upload-label">Loading Page Logo</label>
                                        <div className="upload-preview">
                                            {state.loadingLogoUrl ?
                                                <img alt="Loading logo" src={state.loadingLogoUrl} className="img-fluid" />
                                                :
                                                <div className="empty-state">
                                                    <LineIcon name="image" />
                                                    <span>No logo uploaded</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="custom-file">
                                            <input value={""} className="custom-file-input" accept=".png, .jpeg, .jpg" name="loadingLogo" id="loadingLogo" type="file" onChange={handleFileChange} />
                                            <label className="custom-file-label">{state.loadingLogoFileName ? state.loadingLogoFileName : "Choose file..."}</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-md-4">
                                    <div className="upload-card">
                                        <label className="upload-label">Favicon</label>
                                        <div className="upload-preview favicon-preview">
                                            {state.faviconUrl ?
                                                <img alt="Favicon" src={state.faviconUrl} className="img-fluid" />
                                                :
                                                <div className="empty-state">
                                                    <LineIcon name="image" />
                                                    <span>No favicon uploaded</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="custom-file">
                                            <input value={""} className="custom-file-input" accept=".png, .ico" name="favicon" id="favicon" type="file" onChange={handleFileChange} />
                                            <label className="custom-file-label">{state.faviconFileName ? state.faviconFileName : "Choose file..."}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <h5 className="section-title mb-3">Color Palette</h5>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 theme">
                        <Card>
                            <div className="row g-4">
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="color-field">
                                        <label>Sidebar Background</label>
                                        <p className="color-description">Main navigation background color</p>
                                        <div className="color-input-wrapper">
                                            <input value={state.primaryNavColour} type='color' className="form-control" name="primaryNavColour" onChange={handleChange} />
                                            <span className="color-value">{state.primaryNavColour || '#000000'}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="color-field">
                                        <label>Sidebar Icons</label>
                                        <p className="color-description">Navigation icon color</p>
                                        <div className="color-input-wrapper">
                                            <input value={state.sidebarIconColour} type='color' className="form-control" name="sidebarIconColour" onChange={handleChange} />
                                            <span className="color-value">{state.sidebarIconColour || '#000000'}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="color-field">
                                        <label>Top Navigation Bar</label>
                                        <p className="color-description">Header background color</p>
                                        <div className="color-input-wrapper">
                                            <input value={state.secondaryNavColour} type='color' className="form-control" name="secondaryNavColour" onChange={handleChange} />
                                            <span className="color-value">{state.secondaryNavColour || '#000000'}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="color-field">
                                        <label>Primary Buttons</label>
                                        <p className="color-description">Call-to-action button background</p>
                                        <div className="color-input-wrapper">
                                            <input value={state.primaryButtonColour} type='color' className="form-control" name="primaryButtonColour" onChange={handleChange} />
                                            <span className="color-value">{state.primaryButtonColour || '#000000'}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="color-field">
                                        <label>Button Text</label>
                                        <p className="color-description">Primary button text color</p>
                                        <div className="color-input-wrapper">
                                            <input value={state.primaryNavFontColour} type='color' className="form-control" name="primaryNavFontColour" onChange={handleChange} />
                                            <span className="color-value">{state.primaryNavFontColour || '#000000'}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-6 col-lg-4">
                                    <div className="color-field">
                                        <label>Accent &amp; Icons</label>
                                        <p className="color-description">Icons and accent elements</p>
                                        <div className="color-input-wrapper">
                                            <input value={state.iconColour} type='color' className="form-control" name="iconColour" onChange={handleChange} />
                                            <span className="color-value">{state.iconColour || '#000000'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="d-flex justify-content-end">
                                        <PrimaryButton text="Save Changes" func={handleSubmit} icon="checkmark" />
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ThemeSettings;